@if (!isShowing) {
  @if (draggable) {
    <gb-presenter-widget-placeholder>
      <h1 translate="PRESENTER.NOTIFICATION_WIDGET.AREA_TITLE"></h1>
      <span translate="PRESENTER.NOTIFICATION_WIDGET.HINT"></span>
    </gb-presenter-widget-placeholder>
  }
} @else {
  @let isPopoutA = notificationWidget.notif_type === NotifTypeEnum.POPOUT_A;
  @let isPopoutB = notificationWidget.notif_type === NotifTypeEnum.POPOUT_B;
  @let isToastA = notificationWidget.notif_type === NotifTypeEnum.TOAST_A;

  <div
    class="notif-container"
    [class.popout-a-container]="isPopoutA"
    [class.popout-b-container]="isPopoutB"
    [class.toast-a-container]="isToastA"
    [class.is-shown]="animationState === 'shown'"
    [class.is-hidden]="animationState === 'hidden'"
    [class.no-image]="!notificationImageBackground"
    (animationend)="onNotificationAnimationEnd($event)"
    [style.color]="resolvedColor"
    [style.background-color]="resolvedBackgroundColor"
    [style.--notif-font-size]="notifFontSize"
    [style.font-family]="fontFamily"
    [style.font-weight]="fontWeight"
  >
    @if (isPopoutA && notificationImageBackground) {
      <div
        class="image-container"
        [style.background-size]="imageCover ? 'cover' : 'contain'"
        [style.background-image]="notificationImageBackground"
      ></div>
    }

    @if (isToastA && notificationImageBackground) {
      <div
        class="toast-image"
        [style.background-size]="imageCover ? 'cover' : 'contain'"
        [style.background-image]="notificationImageBackground"
      ></div>
    }

    <div [class]="isToastA ? 'toast-text' : 'text-container'" [style.background-color]="resolvedBackgroundColor">
      <div class="header">{{ activeNotification?.header }}</div>
      <div class="body gb-truncate">{{ activeNotification?.body }}</div>
    </div>

    @if (isPopoutB && notificationImageBackground) {
      <div
        class="image-container"
        [style.background-size]="imageCover ? 'cover' : 'contain'"
        [style.background-image]="notificationImageBackground"
      ></div>
    }

    @if (!notificationWidget.hide_name || !notificationWidget.hide_price) {
      <div
        [class]="isToastA ? 'toast-secondary' : 'secondary-text-container'"
        [style.background-color]="resolvedSecondaryBackgroundColor"
        [style.color]="resolvedSecondaryColor"
      >
        @if (!notificationWidget.hide_name) {
          <div class="secondary-1">{{ activeNotification?.secondary_text_1 }}</div>
        }
        @if (!notificationWidget.hide_price) {
          <div class="secondary-2">{{ activeNotification?.secondary_text_2 }}</div>
        }
      </div>
    }
  </div>
}
